'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _config = _interopRequireDefault(require("Shared/config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const script_src = '/optional_js/tarteaucitron.js';
class CookiesAlert extends _react.Component {
  state = {
    hidden: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (!app.state.cookies_alert) {
      component.init();
    } else {
      if (app.state.cookies_alert === 'error') return;
      if (app.state.cookies_alert === 'init') {
        const script = document.getElementById(state.id);
        script.addEventListener('load', component.executeScript);
      } else if (app.state.cookies_alert === 'ready') {
        component.executeScript();
      }
    }
  }
  init() {
    const component = this,
      props = this.props,
      state = this.state;
    window.tarteaucitronForceCDN = _config.default.cookies_path;
    app.state.cookies_alert = 'init';
    const script = document.createElement('script');
    script.src = script_src;
    script.addEventListener('load', function () {
      app.state.cookies_alert = 'ready';
      if (!window.tarteaucitron) return;
      component.executeScript();
    });
    script.addEventListener('onError', function () {
      app.state.cookies_alert = 'error';
    });
    document.body.appendChild(script);
  }
  executeScript = () => {
    const component = this,
      props = this.props,
      state = this.state;
    app.state.cookies_alert = 'loaded';
    window.tarteaucitron.init({
      cdn: _config.default.cookies_path,
      hashtag: '#gestion-des-cookies',
      cookieName: 'cookies_consent',
      orientation: 'bottom',
      showAlertSmall: false,
      cookieslist: true,
      adblocker: false,
      AcceptAllCta: true,
      highPrivacy: false,
      handleBrowserDNTRequest: false,
      removeCredit: true,
      moreInfoLink: false,
      useExternalCss: true,
      readmoreLink: undefined,
      privacyUrl: ''
    });
    window.setTimeout(function () {
      const UI_id = document.getElementById('tarteaucitronRoot');
      if (!UI_id) {
        window.tarteaucitron.load();
      }
      component.addGoogleAnalytics();
      component.addRecaptcha();
    }, 2000);
  };
  addGoogleAnalytics = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!_config.default.google_analytics) return;
    window.tarteaucitron.user.gtagUa = _config.default.google_analytics;
    (window.tarteaucitron.job = window.tarteaucitron.job || []).push('gtag');
  };
  addRecaptcha = () => {
    const component = this,
      props = this.props,
      state = this.state;
    window.tarteaucitron.job = window.tarteaucitron.job || [];
    window.tarteaucitron.job.push('recaptcha');
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.hidden) return null;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-cookies-alert"
    });
    return output;
  }
}
exports.default = CookiesAlert;
